























































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Widget from "@/shared/components/Widget.vue";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useHsabEnrollmentStore } from "@/employee/store/hsabEnrollment";
import HsabEnrollmentSettingsForm from "@/employee/components/settings/hsaBank/HsabEnrollmentSettingsForm.vue";
import { HsabEnrollmentSettingsUpdateRequest } from "@/shared/types";

  @Component({
    components: {
      HsabEnrollmentSettingsForm,
      Widget,
      GenericLoadingSpinner,
    }
  })
  export default class HsabEnrollmentSettings extends Vue {
    hsabEnrollmentStore = useHsabEnrollmentStore();
    hsabAccountsStore = useHsabAccountsStore();
    isEditing = false;

    mounted () {
     this.hsabEnrollmentStore.loadHsabEnrollmentSettings();
    }
    onEditClicked () {
      this.isEditing = true;
    }
    handleEditClosed () {
      this.isEditing = false;
    }
    handleSave (newSettings: HsabEnrollmentSettingsUpdateRequest) {
       this.isEditing = false;
       this.hsabEnrollmentStore.settingsSavedSuccessfully(newSettings);
    }

    // User will only be able to enroll/unenroll in carrier claims if
    // User has an active plan and AllowOptInOutAutoClaims is true
    get canEditEnrollUnenrollCarrierClaims (): boolean {
      return this.hsabAccountsStore.userHasActiveNotionalAccounts
        && this.hsabEnrollmentStore.settings.allowOptInOutAutoClaims;
    }

    // User will only be able to update Notional autopay  if the following criteria are met:
    // User has an active notional and EnableAutomaticallyFiled is true
    get canEditAutoPayNotional (): boolean {
      return this.hsabAccountsStore.userHasActiveNotionalAccounts
        && this.hsabEnrollmentStore.settings.enableAutomaticallyFiled;
    }

    // User will only be able to turn on HSA autopay if the following criteria are met
    // User has an active HSA and EnableAutomaticallyFiled is true
    get canEditAutoPayHsa (): boolean {
      return this.hsabAccountsStore.userHasHsaAccount
        && this.hsabEnrollmentStore.settings.enableAutomaticallyFiled;
    }
  }
